import { render } from "./TaiXeLichSuXangDau.vue?vue&type=template&id=19072238&scoped=true"
import script from "./TaiXeLichSuXangDau.vue?vue&type=script&lang=js"
export * from "./TaiXeLichSuXangDau.vue?vue&type=script&lang=js"

import "./TaiXeLichSuXangDau.vue?vue&type=style&index=0&id=19072238&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19072238"]])

export default __exports__